const DECIMAL_LITERAL_PREFIXES = new Set([
  "=",
  "+",
  "-",
  "*",
  "/",
  "^",
  "&",
  "<",
  ">",
  "(",
  ",",
  ";",
  "{",
]);

export const normalizeFormulaDecimalLiterals = (formula, caretOffset = null) => {
  if (
    typeof formula !== "string" ||
    !formula.trim().startsWith("=")
  ) {
    return { value: formula, caretOffset };
  }

  let value = "";
  let quote = null;
  let adjustedCaretOffset = caretOffset;

  for (let index = 0; index < formula.length; index++) {
    const character = formula[index];

    if (quote) {
      value += character;
      if (character === quote) {
        if (formula[index + 1] === quote) {
          value += formula[index + 1];
          index++;
        } else if (formula[index - 1] !== "\\") {
          quote = null;
        }
      }
      continue;
    }

    if (character === '"' || character === "'") {
      quote = character;
      value += character;
      continue;
    }

    if (character === "." && /\d/.test(formula[index + 1] || "")) {
      let previousIndex = index - 1;
      while (previousIndex >= 0 && /\s/.test(formula[previousIndex])) {
        previousIndex--;
      }

      const previousCharacter = formula[previousIndex];
      if (
        previousIndex < 0 ||
        DECIMAL_LITERAL_PREFIXES.has(previousCharacter)
      ) {
        value += "0";
        if (
          typeof adjustedCaretOffset === "number" &&
          index < caretOffset
        ) {
          adjustedCaretOffset++;
        }
      }
    }

    value += character;
  }

  return { value, caretOffset: adjustedCaretOffset };
};
